export const PROGRAM_STATUS_TYPES = {
  pending: "warning",
  active: "success",
  cancelled: "danger",
  rejected: "danger",
  completed: "success",
};

export const PROGRAM_STATUS_TEXT = {
  pending: "En revisión",
  active: "Activo",
  cancelled: "Cancelado",
  rejected: "Rechazado",
  completed: "Completado",
};

export function getProgramStatusType(status) {
  return PROGRAM_STATUS_TYPES[status] || "info";
}

export function getProgramStatusText(status) {
  return PROGRAM_STATUS_TEXT[status] || status;
}
